<template>
  <div id="CentralaDodanie">

    <div id="content">

      <table class="table-created">
        <tr>
          <td>model</td><td colspan="2"><input v-model="inputFields.model" type="text" class="form-control form-control-sm inputWsp"></td>
        </tr>
        <tr>
          <td>producent</td><td colspan="2">
            <select v-model="inputFields.producent" name="producent" id="producent" placeholder="obudowa"
            class="form-select form-select-sm" aria-label=".form-select-sm example">
              <option
                v-for="centralaProducent in producenci"
                :key="centralaProducent.id"
                :value="centralaProducent.nazwa"
                >{{ centralaProducent.nazwa }}</option
              >
            </select>
            <!-- <select v-model="inputFields.producent" name="producent" id="producent" placeholder="obudowa"
            class="form-select form-select-sm" aria-label=".form-select-sm example">
              <option
                v-for="centralaProducent in CentraleNazwa"
                :key="centralaProducent"
                :value="centralaProducent"
                >{{ centralaProducent }}</option
              >
            </select> -->
          </td>
        </tr>
        <tr>
          <td>szerokosc</td><td><input v-model="inputFields.szerokosc" type="text" class="form-control form-control-sm inputWsp"></td>
        </tr>
        <tr>
          <td>wysokosc</td><td><input v-model="inputFields.wysokosc" type="text" class="form-control form-control-sm inputWsp"></td>
        </tr>
        <tr>
          <td>wysokosc extra</td><td><input v-model="inputFields.wysokosc_extra" type="text" class="form-control form-control-sm inputWsp"></td>
        </tr>
        <tr>
          <td>p1</td>
          <td class="colinpPunkt">
            <span>x: <input v-model="inputFields.p1x" type="text" class="form-control form-control-sm inpPunkt"></span>
            <span>y: <input v-model="inputFields.p1y" type="text" class="form-control form-control-sm inpPunkt"></span>
          </td>
        </tr>
        <tr>
          <td>p2</td>
          <td class="colinpPunkt">
            <span>x: <input v-model="inputFields.p2x" type="text" class="form-control form-control-sm inpPunkt"></span>
            <span>y: <input v-model="inputFields.p2y" type="text" class="form-control form-control-sm inpPunkt"></span>
          </td>
        </tr>
        <tr>
          <td>p3</td>
          <td class="colinpPunkt">
            <span>x: <input v-model="inputFields.p3x" type="text" class="form-control form-control-sm inpPunkt"></span>
            <span>y: <input v-model="inputFields.p3y" type="text" class="form-control form-control-sm inpPunkt"></span>
          </td>
        </tr>
        <tr>
          <td>p4</td>
          <td class="colinpPunkt">
            <span>x: <input v-model="inputFields.p4x" type="text" class="form-control form-control-sm inpPunkt"></span>
            <span>y: <input v-model="inputFields.p4y" type="text" class="form-control form-control-sm inpPunkt"></span>
          </td>
        </tr>
        <tr>
          <td>p5</td>
          <td class="colinpPunkt">
            <span>x: <input v-model="inputFields.p5x" type="text" class="form-control form-control-sm inpPunkt"></span>
            <span>y: <input v-model="inputFields.p5y" type="text" class="form-control form-control-sm inpPunkt"></span>
          </td>
        </tr>
        <tr>
          <td>p6</td>
          <td class="colinpPunkt">
            <span>x: <input v-model="inputFields.p6x" type="text" class="form-control form-control-sm inpPunkt"></span>
            <span>y: <input v-model="inputFields.p6y" type="text" class="form-control form-control-sm inpPunkt"></span>
          </td>
        </tr>
        <tr>
          <td>aktywna</td>
          <td>
            <select v-model="inputFields.widocznosc" name="widocznosc" id="widocznosc"
                class="form-select form-select-sm" aria-label=".form-select-sm example">
              <option value=1>TAK</option>
              <option value=0>NIE</option>
            </select>
          </td>
        </tr>
      </table>

      <div style="width: 100%;text-align: center;margin-top:20px"><button @click="zapiszCentrale(), $emit('someEvent', true)" class="btn btn-success" style="width:200px" :disabled="!isDisabled">Zapisz</button></div>

      <md-dialog-alert
        :md-active.sync="second"
        md-title="Uwaga!"
        md-content="<span style='color: red;font-size: 20px;'>Wszystkie pola muszą być wypełnione.</span>" />

    </div>

  </div>
</template>

<script>
import { app } from '../mixins/functions'
import { mapGetters } from 'vuex'

export default {
  name: 'CentralaDodanie',
  mixins: [app],
  data () {
    return {
      inputFields: {
        'model': '',
        'producent': null,
        'szerokosc': 0,
        'wysokosc': 0,
        'wysokosc_extra': null,
        'p1x': 0,
        'p1y': 0,
        'p2x': 0,
        'p2y': 0,
        'p3x': 0,
        'p3y': 0,
        'p4x': 0,
        'p4y': 0,
        'p5x': 0,
        'p5y': 0,
        'p6x': 0,
        'p6y': 0,
        'widocznosc': 1
      },
      second: false
    }
  },
  computed: {
    ...mapGetters('products', ['centrale', 'obudowy', 'producenci']),
    isDisabled () {
      if (this.inputFields.model !== '' && this.inputFields.producent !== null && this.inputFields.producent !== '') {
        return true
      }
    }
  },
  methods: {
    zapiszCentrale () {
      const self = this
      this.$store.dispatch('products/send_centrale', {'action': 'add', 'fields': this.inputFields}).then(info => {
        console.log(info)
        self.inputFields = {
          'model': '',
          'producent': null,
          'szerokosc': 0,
          'wysokosc': 0,
          'wysokosc_extra': null,
          'p1x': 0,
          'p1y': 0,
          'p2x': 0,
          'p2y': 0,
          'p3x': 0,
          'p3y': 0,
          'p4x': 0,
          'p4y': 0,
          'p5x': 0,
          'p5y': 0,
          'p6x': 0,
          'p6y': 0,
          'widocznosc': 1
        }
      })
    }
  }
}
</script>

<style scoped>
.colinpPunkt {
  width: 280px;
}
.inpPunkt {
  width: 80px;
  text-align: center;
}
.table-created {
  max-width: 420px;
  width: 100%;
  margin: 0px auto;
}
table.table-created tr {
  height: 40px;
}
table.table-created tr td {
  text-align: left;
}
table.table-created tr td span{
  margin-left: 5px;
}
table.table-created tr td span input {
  width: 115px;
  display: inline-flex;
}

table.table-created tr td:first-child {
  width: 200px;
}
#content {
  max-width: 1200px;
  margin: 0px auto;
}
#content h3 {
  background: beige;
  padding: 10px;
  font-size: 20px;
  text-transform: uppercase;
}
#content .table {
  margin-top:40px
}
#content .table tr.head {
  background: #3f7bc8;
}
#content .table tr th {
font-size: 14px;
font-weight: normal;
color: #fff;
padding: 4px;
border-left: 2px solid white;
}
.inputWsp {
  width:280px;
  text-align: left;
  margin: 0px auto;
}
.md-ripple {
  min-height: 30px;
}
#tabPanel tr td input {
  width: 65px;
  padding: 4px;
  text-align: center;
}
.form-select, .form-control {
  padding: 4px 6px;
}
.inputSmall {
  width:65px;
}
.longSmall {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/CentralaDodanie.vue